import React from "react";
import Polygon from "../VibehutUI/Icons/Polygon";

const NFTRoomCard = ({ icon, iconColor, detail }) => {
  return (
    <div className="pr-10 pt-1 flex flex-col space-y-4 max-w-md">
      <div className="flex p-4 border border-lightGray space-x-1 dark:border-matteGray  rounded-xl mb-3">
        <div className="pt-1">
          <Polygon bgColor={iconColor} />
        </div>

        <div className="pl-1">
          <p className="text-sm font-bold pb-1 dark:text-frescoWhite">NFT</p>
          <p className="text-sm font-normal pr-10 text-darkGray">{detail}</p>
        </div>
      </div>
    </div>
  );
};

export default NFTRoomCard;
